import ScheduleTitleBar from "./ScheduleTitleBar";

export default ScheduleTitleBar;